<div
  class="relative bg-[url('/assets/images/contact.jpg')] bg-blend-multiply bg-black/70 min-h-[40vh] bg-center bg-cover flex justify-center items-center p-3"
>
  <!-- Content -->
  <div
    class="relative z-10 flex flex-col justify-center items-center text-center"
  >
    <h2
      class="text-3xl lg:text-5xl font-extrabold text-center mb-3 text-white"
    >
      Contact us
    </h2>
    <p
      class="text-white font-semibold text-center text-lg lg:text-xl"
    >
      Getting in touch with us is easy, you can fill in the below form or by
      emailing us at
      <out-external-links
        [link]="safeMailtoUrl"
        class="underline underline-offset-1 text-[#3186d0]"
        text="contact&commat;onlyusedtesla.com"
      ></out-external-links>
    </p>
  </div>
</div>

<section class="mx-auto">
  <!-- <section class="px-3 2xl:px-52 py-10 xl:py-20">
    <div
      class="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
    >
      <div class="border bg-white shadow rounded p-4 space-y-2">
        <div class="w-fit text-white bg-blue-500 p-3 rounded">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12.252 18.506a10.4 10.4 0 0 0 1.875-.302a5.2 5.2 0 0 0 2.342.151a1 1 0 0 1 .094-.007c.279 0 .645.16 1.179.497v-.554a.54.54 0 0 1 .28-.472q.349-.197.645-.443c.778-.65 1.217-1.518 1.217-2.436c0-.303-.048-.605-.143-.893q.354-.651.564-1.359c.45.665.692 1.45.695 2.252c0 1.248-.588 2.412-1.607 3.263q-.256.213-.535.392v1.298c0 .446-.522.703-.89.437a14 14 0 0 0-1.08-.72a3 3 0 0 0-.332-.165a6.4 6.4 0 0 1-.935.069c-1.27 0-2.445-.377-3.37-1.008m-6.72-2.595C3.927 14.568 3 12.737 3 10.775c0-4.008 3.832-7.213 8.511-7.213c4.68 0 8.513 3.204 8.513 7.213c0 4.008-3.833 7.212-8.513 7.212q-.789 0-1.555-.12c-.22.051-1.102.568-2.372 1.483c-.46.332-1.112.012-1.112-.547V16.59a8 8 0 0 1-.94-.68m4.455.592q.058 0 .117.009q.69.114 1.407.115c3.953 0 7.116-2.645 7.116-5.852c0-3.206-3.163-5.851-7.115-5.851S4.395 7.57 4.395 10.775c0 1.55.74 3.01 2.046 4.103q.494.412 1.076.74a.68.68 0 0 1 .35.589v1.276c1.005-.665 1.666-.98 2.12-.98"
            />
            <path
              fill="currentColor"
              d="M8.062 12a1.125 1.125 0 1 0 0-2.25a1.125 1.125 0 0 0 0 2.25m3.657 0a1.125 1.125 0 1 0 0-2.25a1.125 1.125 0 0 0 0 2.25m3.656 0a1.125 1.125 0 1 0 0-2.25a1.125 1.125 0 0 0 0 2.25"
            />
          </svg>
        </div>
        <div>
          <h2 class="text-xl font-semibold">Chat with us</h2>
          <p class="text-gray-600">
            Chat with Our Friendly Team on These Platforms.
          </p>
        </div>
        <div class="mt-2 flex items-center gap-3">
          <a
            class="bg-white hover:bg-white/80 text-black rounded-full p-0.5"
            href="mailto:contact@onlyusedtesla.com"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 36 36"
            >
              <path
                fill="currentColor"
                d="M32 6H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-1.54 22H5.66l7-7.24l-1.44-1.39L4 26.84V9.52l12.43 12.37a2 2 0 0 0 2.82 0L32 9.21v17.5l-7.36-7.36l-1.41 1.41ZM5.31 8h25.07L17.84 20.47Z"
                class="clr-i-outline clr-i-outline-path-1"
              />
              <path fill="none" d="M0 0h36v36H0z" />
            </svg>
          </a>
          <a
            class="bg-white hover:bg-white/80 text-black rounded-full p-0.5"
            href="https://web.facebook.com/onlyusedtesla?_rdc=1&_rdr#"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              class="size-8"
            >
              <path
                fill="currentColor"
                d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95"
              />
            </svg>
          </a>
          <a class="text-black" href="https://x.com/onlyusedtesla">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              class="size-7"
            >
              <path
                fill="currentColor"
                d="M9.294 6.928L14.357 1h-1.2L8.762 6.147L5.25 1H1.2l5.31 7.784L1.2 15h1.2l4.642-5.436L10.751 15h4.05zM7.651 8.852l-.538-.775L2.832 1.91h1.843l3.454 4.977l.538.775l4.491 6.47h-1.843z"
              />
            </svg>
          </a>
          <a class="text-black" href="https://www.instagram.com/onlyusedtesla">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                color="currentColor"
              >
                <path
                  d="M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12 2.5c4.478 0 6.718 0 8.109 1.391S21.5 7.521 21.5 12c0 4.478 0 6.718-1.391 8.109S16.479 21.5 12 21.5c-4.478 0-6.718 0-8.109-1.391S2.5 16.479 2.5 12"
                />
                <path
                  d="M16.5 12a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0m1.008-5.5h-.01"
                />
              </g>
            </svg>
          </a>
          <a class="text-black" href="https://www.reddit.com/r/onlyusedtesla">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="size-8"
            >
              <path
                fill="currentColor"
                d="M10.75 13.04c0-.57-.47-1.04-1.04-1.04s-1.04.47-1.04 1.04a1.04 1.04 0 1 0 2.08 0m3.34 2.37c-.45.45-1.41.61-2.09.61s-1.64-.16-2.09-.61a.26.26 0 0 0-.38 0a.26.26 0 0 0 0 .38c.71.71 2.07.77 2.47.77s1.76-.06 2.47-.77a.26.26 0 0 0 0-.38c-.1-.1-.27-.1-.38 0m.2-3.41c-.57 0-1.04.47-1.04 1.04s.47 1.04 1.04 1.04s1.04-.47 1.04-1.04S14.87 12 14.29 12"
              />
              <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m5.8 11.33c.02.14.03.29.03.44c0 2.24-2.61 4.06-5.83 4.06s-5.83-1.82-5.83-4.06c0-.15.01-.3.03-.44c-.51-.23-.86-.74-.86-1.33a1.455 1.455 0 0 1 2.47-1.05c1.01-.73 2.41-1.19 3.96-1.24l.74-3.49c.01-.07.05-.13.11-.16c.06-.04.13-.05.2-.04l2.42.52a1.04 1.04 0 1 1 .93 1.5c-.56 0-1.01-.44-1.04-.99l-2.17-.46l-.66 3.12c1.53.05 2.9.52 3.9 1.24a1.455 1.455 0 1 1 1.6 2.38"
              />
            </svg>
          </a>
          <a class="text-black" href="https://www.youtube.com/@onlyusedtesla">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              class="size-10"
            >
              <path
                fill="currentColor"
                d="m10 15l5.19-3L10 9zm11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73"
              />
            </svg>
          </a>
        </div>
      </div>


      <div class="border bg-white shadow rounded p-4 space-y-2">
        <div class="w-fit text-white bg-blue-500 p-3 rounded">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 512 512"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-miterlimit="10"
              stroke-width="32"
              d="M451 374c-15.88-16-54.34-39.35-73-48.76c-24.3-12.24-26.3-13.24-45.4.95c-12.74 9.47-21.21 17.93-36.12 14.75s-47.31-21.11-75.68-49.39s-47.34-61.62-50.53-76.48s5.41-23.23 14.79-36c13.22-18 12.22-21 .92-45.3c-8.81-18.9-32.84-57-48.9-72.8C119.9 44 119.9 47 108.83 51.6A160 160 0 0 0 83 65.37C67 76 58.12 84.83 51.91 98.1s-9 44.38 23.07 102.64s54.57 88.05 101.14 134.49S258.5 406.64 310.85 436c64.76 36.27 89.6 29.2 102.91 23s22.18-15 32.83-31a159 159 0 0 0 13.8-25.8C465 391.17 468 391.17 451 374Z"
            />
          </svg>
        </div>
        <div>
          <h2 class="text-xl font-semibold">Call us</h2>
          <p class="text-gray-600">Connect with our team over the phone.</p>
        </div>

        <a
          href="tel:+1555000000"
          class="flex items-center hover:text-OUT-Blue transition-colors duration-300 mt-2"
        >
          <span class="mr-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="size-5"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z"
              />
            </svg>
          </span>
          +1 (555) 000-0000
        </a>
      </div>


      <div class="border bg-white shadow rounded p-4 space-y-2">
        <div class="w-fit text-white bg-blue-500 p-3 rounded">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 16 16"
          >
            <g fill="none" stroke="currentColor" stroke-width="1">
              <path
                d="M8 14.5C10.5 11 12.5 8 12.5 6a4.5 4.5 0 1 0-9 0c0 2 2 5 4.5 8.5Z"
              />
              <path d="M10 6a2 2 0 1 1-4 0a2 2 0 0 1 4 0Z" />
            </g>
          </svg>
        </div>
        <div>
          <h2 class="text-xl font-semibold">Visit us</h2>
          <p class="text-gray-600">
            Stop by and meet our friendly team in person.
          </p>
        </div>
        <a
          href="https://maps.app.goo.gl/wFJKnhjRW8rDqV1RA"
          target="_blank"
          class="flex items-center hover:text-OUT-Blue transition-colors duration-300 mt-2"
        >
          <span class="mr-2">📍</span> 47 W 13th St, New York, NY 10011, USA
        </a>
      </div>
    </div>
  </section> -->

  <!--   <section
    class="flex justify-center items-center py-10 px-3 xl:py-20 2xl:px-52 bg-gray-50"
  >
    <div
      class="container mx-auto flex flex-col-reverse lg:flex-row justify-center items-center gap-4"
    >
      <div class="basis-1/2">
        <out-text
          tag="h3"
          class="font-semibold text-3xl"
          content="Looking to Buy Your Next Used Tesla?"
        ></out-text>
        <p class="lg:text-lg text-slate-700">
          Browse our stock of quality used Tesla vehicles  to find and purchace <br> your desired car.

          <out-external-links
            link="/contact"
            class="underline text-[#3186d0]"
            text="Visit Our Listings Page"
          ></out-external-links>

        </p>
      </div>
      <div
        class="w-full xl:basis-1/2 bg-[url('/assets/images/register.jpg')] h-[40vh] xl:h-[45vh] bg-cover bg-center rounded"
      ></div>
    </div>
  </section> -->

  <section class="flex flex-col xl:flex-row justify-center">
    <div class="py-10 px-3 xl:py-20 lg:ps-12 2xl:ps-52 xl:basis-1/2">
      <div class="xl:w-[90%] mx-auto 2xl:mx-0">
        <out-contact-form></out-contact-form>
      </div>
    </div>
    <div
      class="xl:basis-1/2 bg-[url('/assets/images/register.jpg')] bg-cover bg-center"
    >
      <!-- <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d755.7903287594418!2d-73.99694617146744!3d40.73647579820443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25938111d3cdb%3A0x8b732a7f209c1ecc!2s47%20W%2013th%20St%2C%20New%20York%2C%20NY%2010011%2C%20USA!5e0!3m2!1sen!2sgh!4v1741947807292!5m2!1sen!2sgh"
        width="600"
        height="450"
        class="w-full xl:h-full"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe> -->
    </div>
  </section>
</section>
